<script setup lang="ts">
import {Project} from "@/types";
import {Head, router} from "@inertiajs/vue3";
import {useCurrentUser} from "@/composables/user";
import {useUserAvatar} from "@/composables/avatar";
import BaseLayout from "@/layouts/BaseLayout.vue";
import {route} from "ziggy-js";

interface Props {
    project: Project,
    invitation: any
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})

const accept = () => {
    router.put(route('projects.invitations.update', {
        project: props.project.slug,
        user: useCurrentUser.value.name,
    }), {})
}

const refuse = () => {
    router.delete(route('projects.invitations.destroy', {
        project: props.project.slug,
        user: useCurrentUser.value.name,
    }))
}
</script>

<template>
    <Head title="Join project" />
    <v-row
        justify="center"
        class="mt-15 pt-15"
    >
        <v-card :flat="true">
            <v-card-title>
                <v-row
                    justify="center"
                    class="py-5"
                >
                    <v-avatar size="48">
                        <v-img :src="useUserAvatar(props.invitation.host)" />
                    </v-avatar>
                    <div class="mx-5 mt-2 text-h5">
                        +
                    </div>
                    <v-avatar size="48">
                        <v-img :src="useUserAvatar(useCurrentUser.name)" />
                    </v-avatar>
                </v-row>
            </v-card-title>
            <v-card-text class="mt-5 text-h5 text-center font-weight-bold text-black">
                <a
                    class="lh-2 text-primary cursor-pointer text-decoration-none"
                    :href="route('users.show', {user: invitation.host})"
                    target="_blank"
                >{{ invitation.host }}</a> invited you to join {{ project.name }}
            </v-card-text>
            <v-row
                justify="center"
                class="my-3"
            >
                <success-btn
                    rounded="lg"
                    class="border mr-1"
                    @click="accept"
                >
                    Accept invitation
                </success-btn>
                <default-btn
                    rounded="lg"
                    class="border"
                    @click="refuse"
                >
                    Decline
                </default-btn>
            </v-row>
            <v-card-text class="text-body-2 text-grey-darken-3">
                <div class="text-center">
                    <v-icon
                        size="sm"
                        class="mb-1 mr-1"
                    >
                        {{ project.is_public ? 'mdi-web' : 'mdi-lock-outline' }}
                    </v-icon>Members of {{ project.name }} will be able to:
                </div>
                <ul class="mx-15 mt-3 lh-1-5">
                    <li class="pl-1">
                        Access the SFTP server
                    </li>
                    <li class="pl-1">
                        Upload files to the remote server
                    </li>
                    <li class="pl-1">
                        Check your transfer history
                    </li>
                </ul>
            </v-card-text>
        </v-card>
    </v-row>
</template>

<style scoped>
.lh-2 {
    line-height: 2rem;
}
.lh-1-5 {
  line-height: 1.5rem;
}
</style>
